import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import SrText from 'client/components/SrText';
import ButtonDeprecated from 'client/components/ButtonDeprecated';

class SrSimpleMessage extends Component {
  static propTypes = {
    iconUrl: PropTypes.string.isRequired,
    headline: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.node,
    ]).isRequired,
    message: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.node,
    ]).isRequired,
    buttonText: PropTypes.string,
    onClickButton: PropTypes.func,
    className: PropTypes.string,
  };

  render() {
    const { iconUrl, className, headline, message, buttonText, onClickButton } = this.props;

    return (
      <div className={classnames('SrSimpleMessage', className)}>
        <div className='SrSimpleMessageIcon' style={{ backgroundImage: `url(${iconUrl})` }} />
        <SrText
          size='2xl'
          weight='bold'
          display='block'
          align='center'
          leading='2xl'
          className='SrSimpleMessageHeadline'
        >
          {headline}
        </SrText>
        <SrText display='block' align='center' className='SrSimpleMessageMessage'>
          {message}
        </SrText>
        {buttonText && (
          <ButtonDeprecated onClick={onClickButton}>
            {buttonText}
          </ButtonDeprecated>
        )}
      </div>
    );
  }
}

SrSimpleMessage.displayName = 'SrSimpleMessage';

export default SrSimpleMessage;
